import React from 'react'

function IconDom (props) {
  return (
    <svg className={'icon ' + (props.className || '')} id={props.id || ''} aria-hidden='true'>
      <use xlinkHref={'#' + props.code} />
    </svg>
  )
}
export default IconDom
